import { useLayoutEffect, useState, useRef } from 'react';
import Link from '@mui/material/Link';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

import KeysTable from '../KeysTable';

import styles from './KeysListItem.module.css';
import DeleteButton from '../../../../common/components/DeleteButton/DeleteButton';
import Button from '@mui/material/Button';
import ActionGroup from '../../../../common/components/ActionGroup';
import {Permission} from "../../../../components/SessionInfo";
import {hetch} from "../../../../utils/fetch.hooked";
import Alert from "@mui/material/Alert";

function KeysListItem({ id, name, handleEditComplete, handleRemoveItem, permission }) {
  const inputRef = useRef();
  const [expanded, setExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [currentName, setCurrentName] = useState(name);
  const [editError, setEditError] = useState(null);

  const saveEditedName = (id, keyName) => {
    setIsFetching(true);
    hetch(`/api/key_names/${id}`, {
      headers: {'Content-Type': 'application/json'},
      method: 'PATCH',
      body: JSON.stringify({
        key_name: keyName.trim()
      })
    })
        .then((res) => {
          if (res.ok) {
            handleEditComplete(id, keyName);
            setCurrentName(keyName.trim());
            setIsEditing(false);
          } else res.json().then(err => setEditError(err.message))
        })
        .finally(() => {
          setIsFetching(false);
        });
  }

  const removeItem = (id) => {
    setIsFetching(true);
    hetch(`/api/key_names/${id}`, {
      headers: {'Content-Type': 'application/json'},
      method: 'DELETE',
      body: null
    })
      .then(() => {
        handleRemoveItem(id);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  useLayoutEffect(() => {
    if (isEditing) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  return (
    <div className={styles.listItem}>
      <div className={styles.listItemHeader}>
        <ArrowDropDownIcon
          sx={{
            width: '1.5em',
            height: '1.5em',
            transform: `rotate(${expanded ? '0' : '-90'}deg)`,
//            color: isFetching ? 'rgba(0, 0, 0, 0.26)' : 'primary.main'
          }}
        />
        {isEditing ? (
          <TextField
            fullWidth
            sx={{
              paddingRight: '8px',
            }}
            size="small"
            disabled={isFetching}
            inputRef={inputRef}
            value={currentName}
            onChange={(evt) => setCurrentName(evt.target.value?.trimStart().replace(/\s+/g, ' '))}
          />
        ) : (
          <Link
            component='button'
            variant='body1'
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'left',
              minWidth: '30%',
              textTransform: 'initial',
              paddingRight: '8px',
              '&:disabled': {
                color: 'rgba(0, 0, 0, 0.26)',
                textDecorationColor: 'rgba(0, 0, 0, 0.26)'
              }
            }}
            disabled={isFetching}
            onClick={() => setExpanded(prevState => !prevState)}
          >
            {name}
          </Link>
        )}
        <div className={styles.actionButtons}>
          {
            permission === Permission.WRITE
                ? (isEditing
                    ? <ActionGroup>
                        <Button
                          title="Сохранить имя УКЭП"
                          color="success"
                          variant="outlined"
                          disabled={isFetching}
                          onClick={() => saveEditedName(id, currentName)}
                        >
                          { isFetching ? <CircularProgress color="success" size={24}/> : <CheckIcon/> }
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          title="Отменить изменение имени УКЭП"
                          disabled={isFetching}
                          onClick={() => {
                            setCurrentName(name);
                            setIsEditing(false);
                          }}
                        >
                          <RemoveIcon/>
                        </Button>
                      </ActionGroup>
                    : <ActionGroup>
                        <Button
                          title="Редактировать имя УКЭП"
                          variant="contained"
                          color="primary"
                          disabled={isFetching}
                          onClick={() => { setIsEditing(true); setEditError(null); }}
                        >
                          <EditIcon/>
                        </Button>
                        <DeleteButton
                          title="Удалить имя УКЭП"
                          message="Вы действительно хотите удалить имя УКЭП?"
                          isFetching={isFetching}
                          onConfirm={() => removeItem(id)}
                        />
                      </ActionGroup>)
                : null
          }
        </div>
      </div>
      { permission === Permission.WRITE && isEditing && editError ? <div><Alert severity="warning" sx={{mt: 2}}>{editError}</Alert></div> : null }
      {expanded ? (
        <div className={styles.tableWrapper}>
          <KeysTable permission={permission} name={name} />
        </div>
      ) : null}
    </div>
  );
}

export default KeysListItem;
